import Fields from "./ButtercreamCalculatorFields";
import Result from "./ButtercreamCalculatorResult";
import calculate from "./calculate";
import Custom from "../customCalculator/CustomCalculatorFormContainer";

const ButtercreamCalculator = { Fields, Result, Custom, calculate };

export default ButtercreamCalculator;
